import { mapper } from '../../tools/mapping/mapper';
import { MeasureGeneric } from '../../domain/measure-generic';
import { MeasureGenericEntity } from '../entity';
import type { AppDB } from '../db';

export class MeasureGenericRepository {
    constructor(private readonly database: AppDB) {}


    async getMesureGenericEntityByCode(code: string) {
        return await this.database.measureGeneric.where('Code').equals(code).first(async mle => {
            return mle;
        });
    }

    async getMesureGenericByCode(code: string) {
        return await this.database.measureGeneric.where('Code').equals(code).first(async mae => {
            const ma = mapper.map(mae, MeasureGenericEntity, MeasureGeneric);
            return ma;
        });
    }

    async getMesureGenericById(id: number) {
        return await this.database.measureGeneric.where('Id').equals(id).first(async ge => {
            const me = mapper.map(ge, MeasureGenericEntity, MeasureGeneric);
            return me;
        });
    }

    async attachGeneric(measure: MeasureGeneric, interventionId: number) {
        let genericId: number;
        const mme = mapper.map(measure, MeasureGeneric, MeasureGenericEntity);

        const ie = await this.database.getInterventionEntityById(interventionId);
        genericId = await this.database.measureGeneric.add(mme);
        await this.database.interventions.update(interventionId, {
            GenericIds: ie?.GenericIds ? [...ie.GenericIds, genericId] : [genericId]
        });

        return genericId;
    }

    async updateMeasureGeneric(measure: MeasureGeneric) {
        const mle = await this.database.getMesureGenericEntityByCode(measure.Code);
        if (!mle || !mle.Id) {
            return false;
        }
        mapper.mutate(measure, mle, MeasureGeneric, MeasureGenericEntity);
        await this.database.measureGeneric.update(mle.Id, mle);

        return true;
    }

    async cancelGeneric(measure: MeasureGeneric, reason: string) {
        const mle = await this.database.getMesureGenericEntityByCode(measure.Code);
        if (!mle || !mle.Id) {
            return;
        }

        await this.database.measureGeneric.update(mle.Id, { IsCancelled: true, Observation: reason });
        return true;
    }
}
